module.exports = function() {
  return new Worker(__webpack_public_path__ + "574d7cb519450869773c.worker.js");
};